import { cn } from "@/lib/utils"
import * as React from "react"

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>

export const Button = React.forwardRef<HTMLButtonElement, Props>(function Button(
    { className, disabled, ...props },
    ref
) {
    return (
        <button
            ref={ref}
            disabled={disabled}
            className={cn(
                [
                    "group relative inline-flex w-full items-center justify-center overflow-hidden",
                    "rounded-2xl bg-dark px-5 py-3.5",
                    "text-sm font-semibold tracking-wide text-on-dark",
                    "shadow-(--shadow-md) transition-[box-shadow,background-color,filter] duration-200",
                    "hover:cursor-pointer hover:shadow-(--shadow-lg) hover:bg-[color-mix(in_oklab,var(--color-dark),white_7%)]",
                    "active:filter active:brightness-[0.98]",
                    "disabled:cursor-not-allowed disabled:opacity-60",
                    "focus-visible:shadow-(--shadow-lg)",
                ].join(" "),
                className
            )}
            {...props}
        >
            {/* subtle sheen */}
            <span
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
                style={{
                    background:
                        "linear-gradient(115deg, transparent 0%, rgba(255,255,255,0.10) 45%, transparent 70%)",
                }}
            />
            <span className="relative">{props.children}</span>
        </button>
    )
})